import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=2648bed9&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"
import style0 from "./repair.vue?vue&type=style&index=0&id=2648bed9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports